import { postData } from "./api";
export const subScribe = async (data) =>
  await postData(`/api/subscriber`, data);
